<template>
    <div class="border bg-gray-100 rounded p-4 mt-3">
        <div class="mb-4">List with background image</div>
        <div>
            <media-reference
                v-model="data.image"
                :language="language"
                name="image"
                class="mt-3"
                label="* Image"
                :media-types="['Image', 'Logo']"
                @input="updateImage($event)"
            />

            <input-text
                name="title"
                label="* Title"
                v-model="data.title"
                class="mt-3"
            />

            <input-rich-text
                label="Text"
                :name="data.text"
                v-model="data.text"
                :language="language"
                :maxlength="5000"
            />
            <p class="my-1 text-xs text-gray-600">You can use these available shortcodes in Text field: [current_month], [month], [current_year], [year] and [current_abrev_month]</p>

            <rocket-link
                label="CTA button"
                :language="language"
                class="mt-3 max-w-xl"
                v-model="data.cta_button"
                :disabled="data.buttons?.length < ctaButtonEnableMinItems"
                :resettable="true"
            />
            <p class="my-1 text-xs text-gray-600">Only available when 6 or more cards</p>
        </div>
        <draggable
            v-model="data.buttons"
            ghost-class="bg-gray-200"
            handle=".handle"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div v-for="(button, index) in data.buttons"
                 :key="`listWithBackgroundImage-${button.id || button.uuid}`"
                 class="relative mt-2 max-w-8xl item">
                    <div class="flex mt-3 items-center">
                        <rocket-link
                            :language="language"
                            class="mb-3 pl-5"
                            v-model="button.link"
                        />

                        <media-reference
                            :name="`list_with_background_image_[${index}][icon]`"
                            v-model="button.icon"
                            class="ml-3 pl-5"
                            :media-types="['Icon']"
                            @input="updateIcon(index, $event)"
                        />
                        <div
                            @click="handleDelete(index)"
                            class="ml-2 cursor-pointer"
                        >
                            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </div>
                        <div class="ml-4 handle" title="Drag to reorder items">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                            </svg>
                        </div>
                    </div>
                </div>
            <button slot="footer"
                class="mt-6 text-indigo-600 hover:text-indigo-900"
                type="button"
                v-if="data.buttons?.length < maxItems"
                @click="addItem"
            >
                + Add item
            </button>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../../config/siteLanguage'
import {useFroalaStore} from "../../stores/froala";
import {v4 as uuidv4} from "uuid";

export default {
    components: { draggable },
    name: "ListWithBackgroundImage",
    props: {
        value: [Object, Array],
        contentBlockId: Number,
        contentSectionId: Number,
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data() {
        return {
            ctaButtonEnableMinItems: 6,
            maxItems: 8,
            data: this.value?.id ? this.value : this.defaultData(),
            froalaStore: useFroalaStore(),
        };
    },
    updated() {
        this.$emit("input", this.data);
    },
    methods: {
        defaultData() {
            return {
                text: null,
                image: null,
                image_id: null,
                cta_button: {},
                title: "",
                buttons: [],
            }
        },
        defaultButton() {
            return {
                uuid: uuidv4(),
                link: {},
                icon: null,
                icon_id: null,
            }
        },
        addItem(e) {
            e.preventDefault();
            this.data['buttons'].push(this.defaultButton());
        },
        handleDelete: function (indexOfItemToDelete) {
            if (confirm('Are you sure you want to remove this item?')) {
                this.data['buttons'].splice(indexOfItemToDelete, 1);
                if (this.data.buttons?.length < this.ctaButtonEnableMinItems) {
                    this.data.cta_button = {};
                }
            }
        },
        updateIcon: function (index, icon) {
            this.data['buttons'][index].icon_id = (icon && icon.id) ? icon.id : null;
        },
        updateImage: function (image) {
            if (image) {
                this.data['image_id'] = image.id ?? null
            }
        },
    },
    watch: {
        value: function (newValue) {
            this.data = newValue;
        }
    }
};
</script>
